import { render, staticRenderFns } from "./DisposalOrdersFilter.vue?vue&type=template&id=183a3aa6&scoped=true"
import script from "./DisposalOrdersFilter.vue?vue&type=script&lang=js"
export * from "./DisposalOrdersFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183a3aa6",
  null
  
)

export default component.exports